export default {
  getHead: () => {
    return [{ name: "시설물명" }, { name: "소속명" }, { name: "부서명" }, { name: "작성자" }, { name: "작성일" }];
  },
  getCol: (index, value, func) => {
    console.log("func.getContent(value)", func.getContent(value))
    try {
      switch (index) {
      case 0:
        return func.getContent(value).stdInfo.field_name; // 시설물명
      case 1:
        return func.getContent(value).stdInfo.department; // 소속명
      case 2:
        return func.getContent(value).stdInfo.section; // 부서명
      case 3:
        return func.getContent(value).stdInfo.writer_name; // 작성자
      case 4:
        return func.getCreatedDate(value.created_at); // 작성일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = "created_at";
      nav.dateBegin = "nav.value.created_at.sDate";
      nav.dateEnd = "nav.value.created_at.eDate";
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword };
  },
  getSearchKeyword: (nav) => {
    switch (nav.value.searchType) {
    case "시설물명":
      return ["content$body.field_name*%[:default_skw]%"];
    case "소속명":
      return ["content$body.stdInfo.department*%[:default_skw]%"];
    case "작성자":
      return ["content$body.stdInfo.writer_name*%[:default_skw]%"];
    }

    return [];
  },
};
